import { Injectable } from '@angular/core';
import { fromEvent, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class EventObserverService {
    observe<T>(target: any, eventName: string): Observable<T> {
        return fromEvent(target, eventName);
    }
}
